<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import ImageModelPage from '@/components/marketing/ImageModelPage.vue'
import VideoModelPage from '@/components/marketing/VideoModelPage.vue'
import { videoModelBySlug } from '@/data/videoModels'

// /models/:slug is one route for both kinds of model: a video slug shows the video page, any other
// slug the image page (which sends an unknown one to NotFound). Each page registers its head tags
// once, so a hop from one model's "Other models" link to another must remount it: keyed by slug,
// the title, description and JSON-LD follow the route.
const route = useRoute()
const slug = computed(() => String(route.params.slug))
</script>

<template>
  <VideoModelPage v-if="videoModelBySlug(slug)" :key="slug" />
  <ImageModelPage v-else :key="slug" />
</template>
